import { Link } from "react-router-dom";
import { LOGO_URL, CATEGORIES } from "@/lib/api";
import { Heart } from "lucide-react";

export const Footer = () => (
  <footer className="mt-24 bg-purple-950 text-purple-100">
    <div className="mx-auto max-w-7xl px-6 py-16 grid gap-10 md:grid-cols-4">
      <div>
        <img src={LOGO_URL} alt="Ciara's Kidz" className="h-16 w-auto object-contain bg-white rounded-2xl p-2 mb-4" />
        <p className="text-sm text-purple-300 leading-relaxed">
          Adorable, premium fashion for your little stars — from newborn babies to 12 years.
        </p>
      </div>
      <div>
        <h4 className="font-display font-semibold mb-4 text-white">Shop</h4>
        <ul className="space-y-2 text-sm">
          {CATEGORIES.map((c) => (
            <li key={c.key}>
              <Link to={`/shop/${c.key}`} className="text-purple-300 hover:text-white transition">
                {c.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="font-display font-semibold mb-4 text-white">Help</h4>
        <ul className="space-y-2 text-sm text-purple-300">
          <li>Shipping across South Africa</li>
          <li>Size guide (0-24m to 12y)</li>
          <li>Returns & exchanges</li>
          <li>Contact us</li>
        </ul>
      </div>
      <div>
        <h4 className="font-display font-semibold mb-4 text-white">Stock Update</h4>
        <p className="text-sm text-purple-300">
          New season collection — <span className="text-fuchsia-300 font-semibold">Stock available 1st October 2026.</span>
        </p>
      </div>
    </div>
    <div className="border-t border-purple-900 py-6 text-center text-xs text-purple-400 flex items-center justify-center gap-1">
      © 2026 Ciara's Kidz. Made with <Heart className="w-3 h-3 fill-fuchsia-400 text-fuchsia-400" /> in South Africa.
    </div>
  </footer>
);
